<div class="overview-user">
  <div class="sp-inn-top">
      <img src="assets/img/overview-user-bg.jpg" class="sp-top-bg" alt="Img">
      <div class="tech-top-position">
          <div class="tech-image">
                <img width="46px" height="46px" style="border-radius:50%" src="{{UserWidgetData['UserImage']}}" alt="{{bs.getResource('rbkey_PrflSmmryUsrImgLBL')}}">
          </div>
          <div class="tech-top-heading" title="{{UserWidgetData['UserName']}}">{{UserWidgetData['UserNameTrimmed']}}</div>
          <div class="tech-top-subheading" title="{{UserWidgetData['JobRoleName']}}">{{UserWidgetData['JobRoleNameTrimmed']}}</div>
      </div>
  </div>
  <div class="sp-inn-bottom">
      <ul>
          <li *ngIf="bs.showSkillRoleBased && bs.HasVariantAccess(bs.GrowVariantType)">              
              <span class="label-d"><img src="assets/img/skill-icon.png" alt="{{bs.getResource('rbkey_PrflSmmrySkllIcnLBL')}}">{{bs.getResource('rbkey_SkllsLBL')}}</span>
              <span class="points">{{UserWidgetData['TotalSkills']}}</span>
          </li>
          <li *ngIf="bs.HasVariantAccess(bs.LearnVariantType)">
              <span class="label-d"><img src="assets/img/star-icon.png" alt="{{bs.getResource('rbkey_PrflSmmryPntsIcnLBL')}}">{{bs.getResource('rbKey_Gmfctn_PntsLBL')}}</span>
              <span class="points">{{UserWidgetData['GamificationPoints']}}</span>
          </li>
          <li *ngIf="bs.HasVariantAccess(bs.LearnVariantType)">
              <span class="label-d"><img src="assets/img/badges-icon.png" alt="{{bs.getResource('rbkey_PrflSmmryBdgsIcnLBL')}}">{{bs.getResource('rbkey_UsrPrflBdgsLBL')}}</span>
              <span class="points">{{UserWidgetData['GamificationBadges']}}</span>
          </li>
      </ul>
  </div>
</div>